/**
 * Client-side mirrors of the SRF validators, so the user gets immediate feedback instead of a
 * round-trip rejection. The server remains the source of truth.
 */

const GUID_REGEX =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

/** Mirrors KustoAccessValidationRules.MustBeGuid. */
export const isGuid = (value: string): boolean =>
    GUID_REGEX.test(value.trim()) &&
    value.trim() !== '00000000-0000-0000-0000-000000000000';

export const getGuidError = (
    value: string,
    fieldName: string
): string | undefined =>
    value.trim().length > 0 && !isGuid(value)
        ? `${fieldName} must be a non-zero GUID.`
        : undefined;

export const MAX_DISPLAY_NAME_LENGTH = 256;

/** Mirrors the allowlist in KustoAccessValidationRules.MustBeSafeDisplayName. */
const DISPLAY_NAME_REGEX = /^[A-Za-z0-9 ._()/,-]+$/;

/** Mirrors KustoAccessValidationRules.MustBeSafeDisplayName. */
export const isValidDisplayName = (value: string): boolean =>
    value.trim().length <= MAX_DISPLAY_NAME_LENGTH &&
    DISPLAY_NAME_REGEX.test(value.trim());

/** Mirrors KustoAccessValidationRules.MaxFreeTextLength. */
export const MAX_FREE_TEXT_LENGTH = 1024;
